const API_URL = process.env.REACT_APP_API_URL;

export function iosTransaction (payload, callBack) {
    try {
        fetch(`${API_URL}/api/payments/ios-purchase`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
            .then(res => {
                console.log("🧪 iOS fetch status:", res.status);
                if (!res.ok) throw new Error("Request failed");
                return res.json();
            })
            .then(data => {
                console.log("✅ iOS purchase response:", data);
                callBack();
            })
            .catch(err => {
                console.error("❌ Failed to verify iOS purchase:", err);
                alert("Server rejected the purchase: " + err.message);
               callBack();
            });
    } catch (error) {
        console.log("Error in iosTransaction: ", error)
    }
}

export function androidTransaction (payload, callBack) {
    try {
        fetch(`${API_URL}/api/payments/android-purchase`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (!res.ok) throw new Error("Request failed");
                callBack();
                return res.json();
            })
            .then(data => {
                console.log("✅ Purchase verified & voucher received:", data);
            })
            .catch(err => {
                console.error("❌ Failed to verify Android purchase:", err);
            });
    } catch (error) {
        console.log("error in androidTransaction: ", error, "payload: ", payload, "callBack: ", callBack)
    }
}

